import StatusMessage from '@components/StatusMessage/StatusMessage';
import { WITHDRAWN_APPLICATION } from '@utils';
import Exclamation from '../../../assets/exclamation.svg?react';

// Terminal-status screen shown when the application has been withdrawn, so the
// applicant can no longer proceed to the offer/contract-acceptance step. Reuses
// the shared StatusMessage layout (same as the QuoteStatus screens).
function WithdrawnApplication() {
  const { TITLE, MESSAGE } = WITHDRAWN_APPLICATION;

  return <StatusMessage icon={<Exclamation />} title={TITLE} message={MESSAGE} />;
}

export default WithdrawnApplication;
